<template>
	<div class="mall-home">
		<!-- 搜索区域+热门搜索 -->
		<div class="search-section">
			<div class="search-box">
				<div class="search-input-wrap">
					<input
						v-model="searchKeyword"
						class="search-input"
						type="text"
						placeholder="请输入服务名称搜索"
						@keyup.enter="handleSearch"
					/>
					<i v-if="searchKeyword" class="el-icon-circle-close clear-icon" @click="clearSearch"></i>
				</div>
				<el-button type="primary" class="search-btn" @click="handleSearch">搜索</el-button>
			</div>

			<div class="hot-search">
				<img class="hot-search-img" src="@/assets/mall/hot-search.png" alt="热门搜索" />
				<div class="hot-search-list">
					<span v-for="(item, index) in hotSearchList" :key="index" class="hot-search-item" @click="handleHotSearch(item)">
						{{ item }}
					</span>
				</div>
			</div>
		</div>

		<!-- 内容区域 -->
		<div class="content-section">
			<!-- 第一板块 -->
			<div class="main-content">
				<!-- 左侧：数智服务 -->
				<div class="service-category">
					<h3 class="category-title">数智服务</h3>
					<div v-for="(cat, idx) in serviceCategories" :key="idx" class="category-item">
						<div class="category-header">
							<img :src="cat.icon" alt="" />
							<span>{{ cat.name }}</span>
						</div>
						<div class="category-children">
							<span v-for="(child, cIdx) in cat.children" :key="cIdx">{{ child }}</span>
						</div>
					</div>
				</div>

				<!-- 中间：轮播图 -->
				<div class="banner-swiper">
					<div class="swiper-container mall-banner-swiper">
						<div class="swiper-wrapper">
							<div v-for="n in 3" :key="n" class="swiper-slide">
								<img src="@/assets/mall/mall-banner-01.png" alt="轮播图" />
							</div>
						</div>
						<div class="swiper-pagination"></div>
					</div>
				</div>

				<!-- 右侧：服务商展示 -->
				<div class="service-provider">
					<div class="provider-card invitation-card">
						<!-- <img class="invitation-bg" src="@/assets/mall/invitation-bg.png" alt="招商背景" /> -->
						<img class="invitation-text" src="@/assets/mall/invitation-text.png" alt="邀您成为服务商" />
						<div class="invitation-btns">
							<el-button type="primary" size="small" @click="handleToMyShop">我的店铺</el-button>
							<el-button type="primary" plain size="small" @click="handleToBecomeProvider">成为服务商</el-button>
						</div>
					</div>
					<div class="provider-card ad-card">
						<img class="ad-img" src="@/assets/mall/poster/provider-01.jpg" alt="广告图" />
					</div>
					<div class="provider-card ad-card">
						<img class="ad-img" src="@/assets/mall/poster/provider-02.jpg" alt="广告图" />
					</div>
				</div>
			</div>

			<!-- 第二板块：广告图 -->
			<div class="ad-section">
				<div class="ad-item" @click="handleRouterToPurchase('1')">
					<img class="ad-img" src="@/assets/mall/poster/provider-poster-01.png" alt="企业宣传" />
				</div>
				<div class="ad-item" @click="handleRouterToPurchase('2')">
					<img class="ad-img" src="@/assets/mall/poster/provider-poster-02.png" alt="企业风采" />
				</div>
				<div class="ad-item">
					<img class="ad-img" src="@/assets/mall/poster/provider-poster-03.png" alt="广告图" />
				</div>
			</div>
		</div>

		<!-- VIP广告--start -->
		<div class="poster-container">
			<img src="@/assets/index/poster-vip1.png" alt="VIP限时专享，资质办理加速跑" @click="handleLocationMemberBenefits" />
		</div>
		<!-- VIP广告--end -->

		<!-- 热门展销板块 -->
		<hot-exhibition />

		<!-- 不同服务类型展示 -->
		<div class="other-service">
			<div class="tab-pane-container">
				<!-- tab头部区域--start -->
				<div class="tab-pane-header">
					<!-- tab选项 -->
					<div class="tab-pane-navs">
						<div
							v-for="(item, index) in tabs"
							:key="index"
							:class="['tab-pane-item', { active: activeTab === index }]"
							@click="activeTab = index"
						>
							{{ item.name }}
						</div>
					</div>
				</div>
				<!-- tab头部区域--end -->
				<!-- tab内容区域--start -->
				<div class="tab-pane-content">
					<div :class="['tab-pane-content__item', { active: activeTab === 0 }]">
						<div class="goods-card-list">
							<mall-goods-card
								v-for="(item, index) in goodsList"
								:key="index"
								:goods-id="item.goodsId"
								:image="item.image"
								:title="item.title"
								:price="item.price"
								:sold-count="item.soldCount"
								:contact-phone="item.contactPhone"
								:click-count="item.clickCount"
								:location-fn="() => handleCardClick(item)"
							/>
						</div>
					</div>
					<div :class="['tab-pane-content__item', { active: activeTab === 1 }]">
						<div class="goods-card-list">
							<mall-goods-card
								v-for="(item, index) in goodsList"
								:key="index"
								:goods-id="item.goodsId"
								:image="item.image"
								:title="item.title"
								:price="item.price"
								:sold-count="item.soldCount"
								:contact-phone="item.contactPhone"
								:click-count="item.clickCount"
								:location-fn="() => handleCardClick(item)"
							/>
						</div>
					</div>
					<div :class="['tab-pane-content__item', { active: activeTab === 2 }]">
						<div class="goods-card-list">
							<mall-goods-card
								v-for="(item, index) in goodsList"
								:key="index"
								:goods-id="item.goodsId"
								:image="item.image"
								:title="item.title"
								:price="item.price"
								:sold-count="item.soldCount"
								:contact-phone="item.contactPhone"
								:click-count="item.clickCount"
								:location-fn="() => handleCardClick(item)"
							/>
						</div>
					</div>
					<div :class="['tab-pane-content__item', { active: activeTab === 3 }]">
						<div class="goods-card-list">
							<mall-goods-card
								v-for="(item, index) in goodsList"
								:key="index"
								:goods-id="item.goodsId"
								:image="item.image"
								:title="item.title"
								:price="item.price"
								:sold-count="item.soldCount"
								:contact-phone="item.contactPhone"
								:click-count="item.clickCount"
								:location-fn="() => handleCardClick(item)"
							/>
						</div>
					</div>
					<div :class="['tab-pane-content__item', { active: activeTab === 4 }]">
						<div class="goods-card-list">
							<mall-goods-card
								v-for="(item, index) in goodsList"
								:key="index"
								:goods-id="item.goodsId"
								:image="item.image"
								:title="item.title"
								:price="item.price"
								:sold-count="item.soldCount"
								:contact-phone="item.contactPhone"
								:click-count="item.clickCount"
								:location-fn="() => handleCardClick(item)"
							/>
						</div>
					</div>
					<div :class="['tab-pane-content__item', { active: activeTab === 5 }]">
						<div class="goods-card-list">
							<mall-goods-card
								v-for="(item, index) in goodsList"
								:key="index"
								:goods-id="item.goodsId"
								:image="item.image"
								:title="item.title"
								:price="item.price"
								:sold-count="item.soldCount"
								:contact-phone="item.contactPhone"
								:click-count="item.clickCount"
								:location-fn="() => handleCardClick(item)"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import HotExhibition from './components/HotExhibition'
	import MallGoodsCard from '@/components/MallGoodsCard'
	import { mapGetters } from 'vuex'
	import { DISPLAY_SECTOR, SHOP_AUDIT_STATE, SHOP_STATE } from '@/enum/index.js'
	import { queryMyLatestShopApply, queryMyShop } from '@/api/mall'

	// 商城首页
	export default {
		name: 'MallHome',
		components: {
			HotExhibition,
			MallGoodsCard
		},
		props: {},
		data() {
			return {
				searchKeyword: '',
				hotSearchList: [
					'企业宣传',
					'企业资质托管',
					'企业资质诊断',
					'行业数据分析',
					'电子签章',
					'从业人员继续教育',
					'人才招聘与岗位匹配'
				],
				serviceCategories: [
					{
						icon: require('@/assets/mall/icon/mall-service-icon01.png'),
						name: '企业业务办事辅助',
						children: ['资质诊断与托管']
					},
					{
						icon: require('@/assets/mall/icon/mall-service-icon02.png'),
						name: '工程项目管控服务',
						children: ['项目全流程资料管理', '项目数字化管控']
					},
					{
						icon: require('@/assets/mall/icon/mall-service-icon03.png'),
						name: '品牌宣传营销服务',
						children: ['企业宣传定制', '品牌包装推广']
					},
					{
						icon: require('@/assets/mall/icon/mall-service-icon04.png'),
						name: '企业办公管理服务',
						children: ['企业办公管理', '协同办公增值']
					},
					{
						icon: require('@/assets/mall/icon/mall-service-icon04.png'),
						name: '企业发展与人才培训服务',
						children: ['建筑人才招聘', '从业人员继续教育']
					},
					{
						icon: require('@/assets/mall/icon/mall-service-icon04.png'),
						name: '数智赋能与金融服务',
						children: ['行业AI智能化赋能', '工程数字化金融']
					}
				],
				bannerSwiper: null,

				// 当前激活的选项
				activeTab: 0,
				tabs: [
					{ name: '企业业务办事辅助' },
					{ name: '工程项目管控服务' },
					{ name: '品牌宣传营销服务' },
					{ name: '企业办公管理服务' },
					{ name: '企业发展与人才培训服务' },
					{ name: '数智赋能与金融服务' }
				],

				// 示例数据，后期可替换为接口数据
				goodsList: [
					// {
					// 	goodsId: '1',
					// 	image: require('@/assets/mall/goods/goods-signature.png'),
					// 	title: '电子签章',
					// 	price: '400元/年',
					// 	soldCount: 428,
					// 	clickCount: 6243345,
					// 	path: '/mallStore/goods-signature/'
					// },
					{
						goodsId: '2',
						image: require('@/assets/mall/goods/goods-propaganda.png'),
						title: '企业宣传投放',
						price: '1.5w-5w',
						soldCount: 2659,
						clickCount: 6243345,
						path: '/mallStore/goods-propaganda/'
					},
					{
						goodsId: '3',
						image: require('@/assets/mall/goods/goods-corporate.png'),
						title: '企业风采投放',
						price: '1.5w-5w',
						soldCount: 1375,
						clickCount: 6243345,
						path: '/mallStore/goods-corporate/'
					},
					{
						goodsId: '4',
						image: require('@/assets/mall/goods/goods-customized.png'),
						title: '企业风采与宣传定制服务',
						price: '面议',
						contactPhone: '1859234781',
						clickCount: 6243345,
						path: '/mallStore/goods-customized/'
					}
				]
			}
		},
		computed: {
			...mapGetters(['isHasCompany'])
		},
		watch: {},
		created() {},
		mounted() {
			this.$nextTick(() => {
				this.bannerSwiper = new Swiper('.mall-banner-swiper', {
					loop: true,
					autoplay: {
						delay: 5000,
						disableOnInteraction: false
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					}
				})
			})
		},
		methods: {
			// 搜索
			handleSearch() {
				console.log('搜索关键词：', this.searchKeyword)
				// TODO: 调用搜索接口或跳转搜索结果页
			},
			// 清除搜索关键词
			clearSearch() {
				this.searchKeyword = ''
			},
			// 点击热门搜索
			handleHotSearch(keyword) {
				this.searchKeyword = keyword
				this.handleSearch()
			},

			handleCardClick(item) {
				this.$router.push({
					path: item.path + item.goodsId
				})
			},

			async getShopEntryState() {
				const [shopResult, applyResult] = await Promise.all([
					queryMyShop().catch(() => ({ data: null })),
					queryMyLatestShopApply().catch(() => ({ data: null }))
				])
				return {
					shop: shopResult.data || null,
					latestApply: applyResult.data || null
				}
			},
			async handleToMyShop() {
				const { shop, latestApply } = await this.getShopEntryState()
				if (shop && shop.id) {
					this.$router.push('/mall/shop/my')
					return
				}
				if (latestApply && latestApply.id) {
					this.$router.push({
						path: '/mall/shop/apply-detail',
						query: { id: latestApply.id }
					})
					return
				}
				this.$router.push('/mall/shop/apply')
			},
			async handleToBecomeProvider() {
				const { shop, latestApply } = await this.getShopEntryState()
				if (latestApply && Number(latestApply.auditState) === SHOP_AUDIT_STATE.PENDING) {
					this.$router.push({
						path: '/mall/shop/apply-detail',
						query: { id: latestApply.id }
					})
					return
				}
				if (shop && shop.id && Number(shop.shopState) === SHOP_STATE.NORMAL) {
					this.$router.push('/mall/shop/my')
					return
				}
				this.$router.push('/mall/shop/apply')
			},

			// 跳转会员权益办理页面
			handleLocationMemberBenefits() {
				this.$router.push({
					path: '/member-benefits'
				})
			},
			// 跳转购买流程页面
			handleRouterToPurchase(displaySectorType = DISPLAY_SECTOR.COMPANY_PROPAGANDA) {
				// 1. 参数校验
				if (!displaySectorType || !Object.values(DISPLAY_SECTOR).includes(displaySectorType)) {
					console.error('无效的展示板块类型:', displaySectorType)
					return
				}

				// 2. 检查企业绑定状态
				// if (!this.isHasCompany) {
				// 	this.$modal.msgWarning('您尚未绑定企业，请先绑定企业后再进行操作')
				// 	return
				// }

				// 3. 跳转并携带展示板块类型参数
				this.$router.push({
					path: '/mallStore/purchase',
					query: {
						displaySectorType: displaySectorType
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/tab-pane.scss';

	.mall-home {
		background-color: #eff6f9;
		padding-bottom: 40px;

		.search-section {
			width: $main-page-width;
			margin: 0 auto;
			padding: 40px 0;
		}

		.search-box {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 20px;
			margin-bottom: 20px;

			.search-input-wrap {
				position: relative;
				display: flex;
				align-items: center;

				.search-input {
					width: 850px;
					height: 60px;
					padding: 0 40px 0 20px;
					border: 1px solid #ccc;
					border-radius: 4px;
					font-size: 18px;
					color: #333;
					background-color: #fff;
					outline: none;
					transition: border-color 0.3s;

					&::placeholder {
						color: #999;
					}

					&:focus {
						border-color: #236fca;
						box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
					}
				}

				.clear-icon {
					position: absolute;
					right: 12px;
					font-size: 18px;
					color: #c0c4cc;
					cursor: pointer;
					transition: color 0.3s;

					&:hover {
						color: #909399;
					}
				}
			}

			.search-btn {
				width: 120px;
				height: 60px;
				font-size: 18px;
				border-radius: 4px;
				text-align: center;
			}
		}

		.hot-search {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 34px;

			.hot-search-img {
				width: auto;
				height: 34px;
				margin-right: 16px;
				flex-shrink: 0;
			}

			.hot-search-list {
				display: flex;
				align-items: center;
				flex-wrap: wrap;

				.hot-search-item {
					font-size: 16px;
					color: #666;
					cursor: pointer;
					transition: color 0.3s;
					padding: 0 22px;
					position: relative;

					&:hover {
						color: #236fca;
					}

					// 竖线分隔
					& + .hot-search-item::before {
						content: '|';
						position: absolute;
						left: 0;
						color: #ccc;
					}
				}
			}
		}

		// 内容区域
		.content-section {
			width: $main-page-width;
			margin: 0 auto;

			.main-content {
				display: flex;
				gap: 20px;
				align-items: flex-start;

				// 左侧
				.service-category {
					flex: 0 0 310px;
					height: 470px;
					background: #fff;
					padding: 15px 20px;
					box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.05);

					.category-title {
						color: #236fca;
						font-size: 16px;
						font-weight: bold;
						margin-bottom: 16px;
					}

					.category-item {
						margin-bottom: 10px;

						.category-header {
							display: flex;
							align-items: center;
							margin-bottom: 8px;

							img {
								width: 20px;
								height: 20px;
								margin-right: 8px;
							}

							span {
								font-size: 18px;
								color: #333;
								// font-weight: bold;
							}
						}

						.category-children {
							display: flex;
							flex-wrap: wrap;
							padding-left: 28px;

							span {
								flex: 0 0 auto;
								min-width: 50%;
								max-width: 100%;
								font-size: 14px;
								color: #999;
								margin-bottom: 10px;
								cursor: pointer;
								transition: color 0.3s;
								line-height: 1;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								padding-right: 8px;
								box-sizing: border-box;

								&:hover {
									color: #236fca;
								}
							}
						}
					}
				}

				// 中间banner
				.banner-swiper {
					flex: 1;
					min-width: 0;
					height: 470px;

					.mall-banner-swiper {
						width: 100%;
						height: 100%;
						overflow: hidden;

						.swiper-slide {
							img {
								width: 100%;
								// height: 100%;
								object-fit: cover;
							}
						}

						::v-deep(.swiper-pagination) {
							bottom: 20px;

							.swiper-pagination-bullet {
								width: 8px;
								height: 8px;
								background: rgba(255, 255, 255, 0.6);
								opacity: 1;

								&.swiper-pagination-bullet-active {
									background: #236fca;
								}
							}
						}
					}
				}

				// 右侧服务商
				.service-provider {
					flex: 0 0 300px;
					min-width: 0;
					width: 300px;
					display: flex;
					flex-direction: column;
					gap: 20px;

					.provider-card {
						width: 100%;
					}

					.invitation-card {
						position: relative;
						height: 180px;
						background-image: url('~@/assets/mall/invitation-bg.jpg');
						background-size: cover;
						background-repeat: no-repeat;
						border: 1px solid #fff;

						.invitation-bg {
							width: 100%;
							height: 120px;
							object-fit: cover;
							display: block;
						}

						.invitation-text {
							position: absolute;
							top: 37px;
							left: 50%;
							transform: translateX(-50%);
							width: 70%;
						}

						.invitation-btns {
							position: absolute;
							bottom: 15px;
							left: 0;
							right: 0;
							display: flex;
							justify-content: center;
							gap: 10px;

							.el-button {
								min-width: 90px;

								&.is-plain {
									background-color: #fff;
								}
							}
						}
					}

					.ad-card {
						height: 125px;
						// border-radius: 8px;
						overflow: hidden;
						cursor: pointer;
						transition: transform 0.3s ease, box-shadow 0.3s ease;

						&:hover {
							transform: translateY(-5px);
							box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
						}

						.ad-img {
							width: 100%;
							height: 100%;
							object-fit: cover;
							display: block;
							transition: transform 0.3s ease;
						}

						&:hover .ad-img {
							transform: scale(1.05);
						}
					}
				}
			}

			.ad-section {
				display: flex;
				gap: 30px;
				margin-top: 30px;

				.ad-item {
					flex: 1;
					height: 150px;
					// border-radius: 8px;
					overflow: hidden;
					cursor: pointer;
					transition: transform 0.3s ease, box-shadow 0.3s ease;

					&:hover {
						transform: translateY(-5px);
						box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
					}

					.ad-img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						transition: transform 0.3s ease;
					}

					&:hover .ad-img {
						transform: scale(1.05);
					}

					.ad-placeholder {
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						color: #236fca;
						font-size: 16px;
					}
				}
			}
		}

		// 其他服务展示
		.other-service {
			width: $main-page-width;
			margin: 0 auto;
			background: #ffffff;
			box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
			border-radius: 6px;
			margin-top: 30px;
			padding: 20px;
		}
	}

	// 卡片列表：4列网格布局
	.goods-card-list {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 20px;
		padding: 20px;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.05);
	}
</style>
